<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'NAVIGATION.TABS.EMAILS' | translate }}
    </glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <div class="email-list-container">
      <va-filter2 [formGroup]="filterGroup">
        <va-filter-sections>
          <va-filter-section>
            <va-filter-section-title>
              {{ 'PAGES.EMAILS.TABLE.PARTICIPANTS' | translate }}
            </va-filter-section-title>
            <va-filter-field [formGroup]="filterGroup">
              <input
                matInput
                type="text"
                formControlName="to"
                placeholder="{{ 'PAGES.EMAILS.TABLE.HEADERS.TO' | translate }}"
                />
            </va-filter-field>
            <va-filter-field [formGroup]="filterGroup">
              <input
                matInput
                type="text"
                formControlName="from"
                placeholder="{{
                  'PAGES.EMAILS.TABLE.HEADERS.FROM' | translate
                }}"
                />
            </va-filter-field>
            <br />
          </va-filter-section>

          <va-filter-section>
            <va-filter-section-title>
              {{ 'PAGES.EMAILS.TABLE.DATES' | translate }}
            </va-filter-section-title>
            <va-filter-field [formGroup]="filterGroup">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="sentAfterPicker"
                  placeholder="{{
                    'PAGES.EMAILS.TABLE.SENT_AFTER' | translate
                  }}"
                  formControlName="sentAfter"
                  />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="sentAfterPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #sentAfterPicker></mat-datepicker>
              </mat-form-field>
            </va-filter-field>

            <va-filter-field [formGroup]="filterGroup">
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="sentBeforePicker"
                  placeholder="{{
                    'PAGES.EMAILS.TABLE.SENT_BEFORE' | translate
                  }}"
                  formControlName="sentBefore"
                  />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="sentBeforePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #sentBeforePicker></mat-datepicker>
              </mat-form-field>
            </va-filter-field>
          </va-filter-section>
        </va-filter-sections>

        <va-filter-toolbar>
          <va-search-box
            (update)="emailDataSource.updateSearchTerm($event)"
          ></va-search-box>
        </va-filter-toolbar>

        <va-filter-content>
          <mat-table [dataSource]="emailDataSource">
            <ng-container matColumnDef="timestamp" class="mat-column-timestamp">
              <mat-header-cell *matHeaderCellDef class="error-timestamp-column">
                {{ 'PAGES.PHP_LOGS.TABLE.HEADERS.TIMESTAMP' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let email" class="error-timestamp-column">
                <span class="date">
                  {{ email.timestamp | date: 'mediumDate' }}
                </span>
                <span class="timestamp">
                  {{ email.timestamp | date: 'mediumTime' }}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="to">
              <mat-header-cell *matHeaderCellDef>
                {{ 'PAGES.EMAILS.TABLE.HEADERS.TO' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let email" class="hide-overflow">
                @for (t of email.to; track t) {
                  <div>
                    <span title="{{ t.name }}">{{ t.name }}</span>
                    <div
                      class="small-text hide-overflow"
                      title="{{ t.emailAddress }}"
                      >
                      {{ t.emailAddress }}
                    </div>
                  </div>
                }
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="from">
              <mat-header-cell *matHeaderCellDef>
                {{ 'PAGES.EMAILS.TABLE.HEADERS.FROM' | translate }}
              </mat-header-cell>
              <mat-cell *matCellDef="let email" class="hide-overflow">
                <span title="{{ email.from.name }}">
                  {{ email.from.name }}
                </span>
                <div
                  class="small-text hide-overflow"
                  title="{{ email.from.emailAddress }}"
                  >
                  ({{ email.from.emailAddress }})
                </div>
              </mat-cell>
            </ng-container>

            <ng-container
              matColumnDef="subject"
              class="mat-column-subject hide-overflow"
              >
              <mat-header-cell *matHeaderCellDef>
                {{ 'PAGES.EMAILS.TABLE.HEADERS.SUBJECT' | translate }}
              </mat-header-cell>
              <mat-cell
                *matCellDef="let email"
                class="hide-overflow"
                title="{{ email.subject }}"
                >
                {{ email.subject }}
              </mat-cell>
            </ng-container>

            <mat-header-row
              *matHeaderRowDef="displayedColumns"
            ></mat-header-row>
            <mat-row
              *matRowDef="let email; columns: displayedColumns"
              (click)="previewEmail(email)"
            ></mat-row>
          </mat-table>

          @if (
            (emailDataSource.loading$ | async) === true) {
            <mat-spinner
              class="total-table-spinner"
              color="accent"
              mode="indeterminate"
            ></mat-spinner>
          } @else {
            @if ((emailDataSource.emailsCount$ | async) === 0) {
              <div class="no-emails">
                <img [src]="noEmailsImageUrl | async" alt="log" />
                <p>
                  <span class="title">
                    {{ 'PAGES.EMAILS.NO_EMAILS.TITLE' | translate }}
                  </span>
                  <br />
                  <span class="subtitle">
                    {{ 'PAGES.EMAILS.NO_EMAILS.SUBTITLE' | translate }}
                  </span>
                </p>
              </div>
            }
          }


          <mat-paginator
            [pageSize]="emailDataSource.pageSize$ | async"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [length]="emailDataSource.totalResults"
            [showFirstLastButtons]="true"
            (page)="emailDataSource.pageOptionsChanged($event)"
          ></mat-paginator>
        </va-filter-content>
      </va-filter2>
    </div>
  </glxy-page-wrapper>
</glxy-page>
